import { render, staticRenderFns } from "./ContributorCard.vue?vue&type=template&id=7f1af3de"
import script from "./ContributorCard.vue?vue&type=script&lang=js"
export * from "./ContributorCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports